import { render, staticRenderFns } from "./ListDescription.vue?vue&type=template&id=dab62d18&scoped=true&"
import script from "./ListDescription.vue?vue&type=script&lang=js&"
export * from "./ListDescription.vue?vue&type=script&lang=js&"
import style0 from "./ListDescription.vue?vue&type=style&index=0&id=dab62d18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab62d18",
  null
  
)

export default component.exports